import type { JSX } from "preact";
import { Badge } from "./Badge";

interface Props {
    title?: string;
    className?: string;
    children: unknown[];
}

export function BadgeLength({
    title,
    className,
    children,
    ...rest
}: Props): JSX.Element {
    return (
        <Badge title={title} className={className} {...rest}>
            {children.length}
        </Badge>
    );
}
